import React from "react";
import {
  breakpointClasses,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import { directionMap, itemsMap, justifyMap, wrapMap } from "../consts";
import type { FlexElement, FlexProps } from "../types";

function FlexRoot<E extends React.ElementType = FlexElement>({
  as,
  asChild = false,
  inline,
  direction = "row",
  justify = "center",
  items = "center",
  gap = "~gap-2/8",
  wrap = "nowrap",
  fill = false,
  className,
  children,
  ...props
}: FlexProps<E>) {
  const Component = resolveElement(asChild, as, "div");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Flex] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        inline ? "inline-flex" : "flex",
        directionMap[direction],
        justifyMap[justify],
        itemsMap[items],
        gap,
        wrapMap[wrap],
        fill && "w-full h-full",
        className,
        classes,
      )}
      {...native}
    >
      {children}
    </Component>
  );
}

FlexRoot.displayName = "Flex";

export default FlexRoot;
